import React, {useEffect, useRef, useState} from "react";
import {EnterDetailsPageContainer} from "../EnterDetailsPage";
import {createStructuredSelector} from "reselect";
import * as selectors from "../../../selectors";
import * as globalActions from "../../../actions";
import {connect} from "react-redux";
import styled from 'styled-components';
import TimeIcon from "../../../assets/icons/Time.svg";
import {convertToMins} from "../CalendarPage/utils";
import ErrorIcon from "../../../assets/icons/error-x-icon.svg";
import {PAGES} from "../../../common/constants";

const GetInputsContainer = styled.div`
  width: 376px;
  display: flex;
  flex-direction: column;
  & *{
    text-align: start;
  }
`;

const ErrorText=styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
`;

const GetInputsTitle =styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #010D39;
  margin-bottom: 10px;
`;

const GetInputsDescription = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #546B8F;
  margin-bottom: 16px;
`

const GetInputsDurationContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
`;

const TimeBarText = styled.p`
  font-family: "Poppins" !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  color: #525F76;
  margin-left:8px;
  margin-right: ${p => p.marginRight ? p.marginRight+"px" : ''};
  margin-top: 0;
  margin-bottom: 0;
`;

const GetInputsInputContainer = styled.div`
  
`;

const GetInputsInputFieldContainer = styled.div`
  font-family: 'Poppins';
`;

const GetInputsInputFieldLabel = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #010D39;
  margin-bottom: 4px;
`;

const GetInputsInputField = styled.input`
  width: 100%;
  margin: 0;
  padding: 7px 8px;
  font-family: "Poppins";
  border: ${p => p.isErrored ? "1px solid #CF0636 !important" : "1px solid #6D84AB !important"};
  outline: none !important;
  border-radius: 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
`;

const ProceedButton = styled.div`
  border-radius: 100vmax;
  background-color: #005BFB;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  cursor: pointer;
  width: max-content;
  padding: 7px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${p => p.isErrored ? '8px' : '-16px'};
  margin-bottom: ${p => p.isErrored ? '' : '24px'};
`;

const ErrorContainer = styled.div`
  color: #CF0636;
  display: flex;
  margin-top: 6px;
  min-height: 20px;
`

const Icon = styled.img`
  width: 16px;
  height: 16px;
  display: block;
`;

const ErrorImageContainer = styled.img`
    margin-right: 4px;
`

const GetInputsPage = props => {
    const {
        isIframe,
        meeting,
        setProspect,
        requiredFields,
        setPage,
        getSlots,
        prospect,
        getCaptchaToken,
    } = props;

    const getInitialRequiredValues = () => {
        if(Object.keys(requiredFields).length !== 0) return requiredFields;
        else if(prospect && Object.keys(prospect).length !== 0) return prospect;
        else return {};
    }

    const getInitialErrorFields = () => {
        let errorObj = {};
        if(Object.keys(requiredFields).length !== 0) {
            let requiredFieldArray = Object.keys(requiredFields);
            for(let i=0; i<requiredFieldArray.length; i++){
                errorObj[requiredFieldArray[i]] = "";
            }
            return errorObj;
        }
        else if(prospect && Object.keys(prospect).length !== 0) {
            let requiredFieldArray = prospect && Object.keys(prospect);
            for(let i=0; i<requiredFieldArray.length; i++){
                errorObj[requiredFieldArray[i]] = "";
            }
            return errorObj;
        }
        else return {};
    }

    const [requiredFieldValues, setRequiredFieldValues] = useState(getInitialRequiredValues());
    const [errorFields, setErrorFields] = useState(getInitialErrorFields());

    const isErrored = key => {
        if(!key){
            let errorFieldArray = Object.keys(errorFields);
            for(let i=0; i<errorFieldArray.length; i++){
                if(errorFields[errorFieldArray[i]] && errorFields[errorFieldArray[i]]!==''){
                    return true;
                }
            }
        }
        else if(errorFields[key] && errorFields[key] !=='') return true;
        return false;
    }

    const isFilled = () => {

    }

    return isIframe ? (
        <EnterDetailsPageContainer>

        </EnterDetailsPageContainer>

    ) : (
        <GetInputsContainer>
            <GetInputsTitle>{meeting.title}</GetInputsTitle>
            <GetInputsDurationContainer>
                <Icon src={TimeIcon} />
                <TimeBarText marginRight={4}>{convertToMins(meeting.duration)}</TimeBarText>
            </GetInputsDurationContainer>
            <GetInputsDescription>{meeting.description}</GetInputsDescription>
            <GetInputsInputContainer>
                {Object.keys(requiredFieldValues).map(key => {
                    return (
                        <GetInputsInputFieldContainer>
                            <GetInputsInputFieldLabel>Enter your {key}</GetInputsInputFieldLabel>
                            <GetInputsInputField
                                type={key==="email" ? "email" : "text"}
                                value={requiredFieldValues[key]}
                                isErrored={isErrored(key)}
                                onChange={(e) => {
                                    let newValues = {...requiredFieldValues};
                                    newValues[key] = e.target.value;
                                    setRequiredFieldValues(newValues);
                                    setErrorFields(requiredFields);
                                }}
                            />
                            <ErrorContainer isErrored={errorFields[key] && errorFields[key]!==''}>
                                {isErrored(key) && <ErrorImageContainer src={ErrorIcon}/>}
                                {isErrored(key) && <ErrorText>{errorFields[key]}</ErrorText>}
                            </ErrorContainer>
                        </GetInputsInputFieldContainer>
                    )
                })}
            </GetInputsInputContainer>
            <ProceedButton
                isErrored={isErrored()}
                disabled={isFilled()}
                onClick={async () => {
                    let fields = Object.keys(requiredFieldValues);
                    let flag = false;
                    let errorObj = {...errorFields};
                    for(let i=0; i<fields.length; i++){
                        if(requiredFieldValues[fields[i]].length === 0){
                            errorObj[fields[i]] = "This field is required.";
                            flag=true;
                        }
                        else if(fields[i] === "email" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(requiredFieldValues[fields[i]])){
                            errorObj[fields[i]] = "Invalid e-mail.";
                            flag=true;
                        }
                    }
                    if(flag === true){
                        setErrorFields(errorObj);
                    } else {
                        let captchaToken = await getCaptchaToken();
                        setProspect(requiredFieldValues);
                        getSlots({prospect: requiredFieldValues, captchaToken})
                        setPage(PAGES.CALENDAR_PAGE);
                    }
            }}>Proceed</ProceedButton>
        </GetInputsContainer>
    );
}

export const mapStateToProps = (state, props) => {
    return createStructuredSelector({
        meetingDetails: selectors.makeSelectMeetingDetails(),
        captchaToken: selectors.makeSelectCaptchaToken(),
        meeting: selectors.makeSelectMeeting(),
        prospect: selectors.makeSelectProspect(),
        requiredFields: selectors.makeSelectRequiredFields(),
    });
};

export const mapDispatchToProps = dispatch => {
    return {
        setPage: payload => dispatch(globalActions.setPage(payload)),
        setProspect: payload => dispatch(globalActions.setProspect(payload)),
        getSlots: meta => dispatch(globalActions.getSlots.start(meta)),
    };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(GetInputsPage);